import extractRawElm from './extract-raw-elm'

import { toPairs, isArray, isFinite, isString, kebabCase } from 'lodash-es'

import {
  isEmpty,
  toPixel,
  isPixel,
  isPercent
} from './bits'

const pxNeeded = [
  'top',
  'left',
  'right',
  'bottom',
  'width',
  'height',
  'max-width',
  'min-width',
  'max-height',
  'min-height',
  'margin',
  'margin-top',
  'margin-left',
  'margin-right',
  'margin-bottom',
  'padding',
  'padding-top',
  'padding-left',
  'padding-right',
  'padding-bottom',
  'border-width',
  'outline-width'
]

export default function setCss(input, defObj, value) {
  if (isArray(input)) {
    for (const $elm of input) {
      setCss($elm, defObj, value)
    }
  } else if (isString(defObj)) {
    setCssPair(input, defObj, value)
  } else {
    for (const [cssKey, cssVal] of toPairs(defObj)) {
      setCssPair(input, cssKey, cssVal)
    }
  }

  return input
}

function setCssPair($elm, key, value) {
  const elm = extractRawElm($elm)
  const cssKey = kebabCase(key)

  const castVal = isFinite(value)
    ? toPixelIfNeeded(cssKey, value)
    : value

  if (isEmpty(castVal)) {
    elm.style.setProperty(cssKey, undefined)
    elm.style.setProperty(cssKey, '')
  } else {
    elm.style.setProperty(cssKey, castVal, 'important')
  }

  return $elm
}

function toPixelIfNeeded(cssKey, value) {
  if (isPercent(value) || isPixel(value)) {
    return value
  }

  const needed = pxNeeded.indexOf(cssKey) !== -1
  return needed ? toPixel(value) : value
}
